import { render, staticRenderFns } from "./MyProjectsOfferDetail.vue?vue&type=template&id=12084538&scoped=true"
import script from "./MyProjectsOfferDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectsOfferDetail.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyProjectsOfferDetail.vue?vue&type=style&index=0&id=12084538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12084538",
  null
  
)

export default component.exports